import { schema } from 'normalizr';

const settingUsersSchema = [new schema.Entity('settingUsers')];

export {
  settingUsersSchema,
};
